import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Link } from "../";
import permissions from "../../mocks/menuPermissions.json";
import { camelCase } from "lodash";
import authService from "../api-authorization/AuthorizeService";
const AddPlans = ({
  menu,
  subMenu,
  content,
  buttonLabel,
  link,
  className,
  disabled,
  secondaryButtonLabel,
  secondaryButtonLink,
  secondaryDisabled,
  onPrimaryClick,
  errorMessage,
  showError,
  errorList,
}) => {
  var isAllowed;
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  if (menu) {
    isAllowed = subMenu
      ? permissions[roleName][menu + "SubMenu"][camelCase(subMenu)].includes(
          "C"
        ) ||
        permissions[roleName][menu + "SubMenu"][camelCase(subMenu)].includes(
          "U"
        )
      : permissions[roleName]["menuItems"][menu].includes("C");
  } else {
    isAllowed = true;
  }

  return (
    <div
      className={`add-module-items d-flex align-items-center justify-content-start h-75 bg-white ${className} add-items`}
    >
      <div className="p-5">
        <h4 className="mb-3">{content}</h4>
        <div className="d-flex">
          {isAllowed && secondaryButtonLabel && (
            <>
              <Link to={secondaryButtonLink} disabled={secondaryDisabled}>
                <Button
                  type="button"
                  variant="secondary"
                  disabled={secondaryDisabled}
                >
                  {secondaryButtonLabel}
                  {errorList?.marketTimingRule}
                </Button>
              </Link>
              &nbsp;&nbsp;&nbsp;
            </>
          )}

          {isAllowed && buttonLabel && (
            <Link to={link} disabled={disabled}>
              <Button
                type="button"
                disabled={disabled}
                onClick={onPrimaryClick}
              >
                {buttonLabel}
              </Button>
            </Link>
          )}
        </div>
        <div style={{ color: "#FF5050" }}>{errorList?.marketTimingRule}</div>
        {showError && (
          <div className="invalid-feedback d-block">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

export default AddPlans;
